import { inject } from '@angular/core';
import { ResolveFn, Routes } from '@angular/router';
import { PromoBannerListComponent } from '@adm-web-app/modules/promo-banners/pages/list/promo-banner-list.component';
import { PromoBannerEditComponent } from '@adm-web-app/modules/promo-banners/pages/edit/promo-banner-edit.component';
import { PromoBannerService } from '@adm-web-app/services/promo-banner.service';
import { PromoBannerModel } from 'hx-services';

const promoBannerResolverFn: ResolveFn<PromoBannerModel> = route => inject(PromoBannerService).getPromoById(Number(route.paramMap.get('id')));

export const promoBannersRoutes: Routes = [
  {
    path: '', component: PromoBannerListComponent,
    data: {
      breadcrumb: 'List'
    }
  },
  {
    path: 'new', component: PromoBannerEditComponent,
    data: {
      breadcrumb: 'Create'
    }
  },
  {
    path: ':id/edit', component: PromoBannerEditComponent,
    resolve: {
      model: promoBannerResolverFn
    },
    data: {
      breadcrumb: 'Edit'
    }
  },
];
